import { render, staticRenderFns } from "./password-form.vue?vue&type=template&id=d7638d2e"
import script from "./password-form.vue?vue&type=script&lang=js"
export * from "./password-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports